module.exports = __webpack_public_path__ + "img/exam_banner.e9f28eea.png";